import React from 'react'
import { useDocumentTitle } from '@uidotdev/usehooks'
import PageBase from 'components/page-title/PageBase'
import HomeIcon from '@mui/icons-material/Home'
import WelcomeHomeUserModal from './components/HomeWelcomeUserModal'
import { useFantaHockeyContext } from 'providers/AuthProvider'
import HomeGridLayout from './components/HomeGridLayout'
import EditHomeLayout from './components/EditHomeLayout'
import { isMobile } from 'react-device-detect'
import { Box } from '@mui/material'

const Home: React.FC = () => {
  useDocumentTitle('FantaHockey | Home')
  const fantaHockeyContext = useFantaHockeyContext()
  const [open, setOpen] = React.useState(false)
  const [isEditing, setIsEditing] = React.useState(false)

  React.useEffect(() => {
    if (fantaHockeyContext.isFirstLogin) {
      setOpen(true)
    }
  }, [fantaHockeyContext.isFirstLogin])

  const handleCloseModal = React.useCallback(() => {
    setOpen(false)
  }, [open, setOpen])

  return (
    <PageBase icon={HomeIcon} title={'Home'}>
      <Box height={'20px'} width={'100%'}>
        {isMobile ? <></> : <EditHomeLayout isEditing={(value: boolean | ((prevState: boolean) => boolean)) => { setIsEditing(value) }} />}
        <WelcomeHomeUserModal open={open} onClose={handleCloseModal} />
        <HomeGridLayout isEditing={isEditing} />
      </Box>
    </PageBase>
  )
}

export default React.memo(Home)
